
import React,{useEffect,useRef,useState,forwardRef} from 'react'
import styles from './controller-narrative.module.css'
import ControllerServerComs from 'system/ControllerServerComs'
import {getContentPath} from 'system/AssetManager';
import {ReactComponent as CaretRight} from '../assets/icons/caret_right.svg'
import {ReactComponent as CaretLeft} from '../assets/icons/caret_left.svg'

import nstyles from '../narrative/narrative.module.scss'
// import mstyles from '../narrative/modules/modules.module.css'
// import {ReactComponent as CloseButton} from '../assets/icons/close.svg'
// import Globals from 'system/Globals'

const ControllerPDFUI = forwardRef( (props ,ref)=>{
    

    useEffect(()=>{
     
        // eslint-disable-next-line react-hooks/exhaustive-deps   
    },[])

    // useEffect(() => {
    //     console.log("props.vidIsPlaying", props.vidIsPlaying)
    //     if (props.vidIsPlaying) {
    //         ControllerServerComs.instance().sendUDPFromControllerToServer('module-gallery-command', "vidplay");
    //     } else {
    //         ControllerServerComs.instance().sendUDPFromControllerToServer('module-gallery-command', "vidpause");
    //     }
    // }, [props.vidIsPlaying])

    const hasPrev = props.pageNumber > 1;
    const hasNext = props.thumbnailsLoading || (props.totalPages > 0 && props.pageNumber < props.totalPages);

    const loadingPlaceholder = (
        <span style={{display:'flex', alignItems:'center', justifyContent:'center', height:'100%'}}>
            <span style={{width:'80%', height:'60%', background:'rgba(255,255,255,0.15)', borderRadius:'10px', animation:'pulse-opacity 1s ease-in-out infinite alternate'}} />
        </span>
    );

    return (

        <section ref={ref} className={`${styles.galleryPopup} ${styles.videoControls}`}>
        <div className={`${styles.videoButtons} ${styles.pdfButtons}`}>
            <div className={`${styles.videoBtnRow}`}>
                <div className={`${styles.videoBtn} ${styles.prevBtn} ${nstyles.pageBtn} ${!props.prevImage && !hasPrev && styles.noImage}`} style={{opacity: !hasPrev ? 0 : 1}} onClick={props.onPrevClick}>

                <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> <CaretLeft /></span>

                  {props.prevImage && <span style={{display:'flex', alignItems:'center', justifyContent:'center', height:'100%'}}>
                        <img src={props.prevImage.startsWith('data:') ? props.prevImage : getContentPath(props.prevImage)} alt="screenshot" style={{borderRadius:'10px', maxHeight:'90%', maxWidth:'80%', width:'auto', height:'auto', float:'none', display:'block'}} />
                    </span>}
                  {!props.prevImage && hasPrev && props.thumbnailsLoading && loadingPlaceholder}

                </div>
                <div className={`${styles.videoBtn} ${!props.nextImage && !hasNext && styles.noImage}`} style={{opacity: !hasNext ? 0 : 1}} onClick={props.onNextClick}>

                  {props.nextImage && <span style={{display:'flex', alignItems:'center', justifyContent:'center', height:'100%'}}>
                        <img src={props.nextImage.startsWith('data:') ? props.nextImage : getContentPath(props.nextImage)} alt="screenshot" style={{borderRadius:'10px', maxHeight:'90%', maxWidth:'80%', width:'auto', height:'auto', float:'none', display:'block'}} />
                    </span>}
                  {!props.nextImage && hasNext && props.thumbnailsLoading && loadingPlaceholder}
                     <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> <CaretRight /></span>
                </div>
            </div>

        </div>

    </section>
    )

})

export default ControllerPDFUI
